import {IonButton, IonHeader, IonTitle} from "@ionic/react";
import React, {useEffect} from "react";
import useAuth from "../../hooks/useAuth";

interface HeaderProps {
    pageTitle: string;

}

export const AcaHeader = ({pageTitle} : HeaderProps) => {

    const { claims } = useAuth();

    const hasRule = (rule: string) => {
        if (claims.rules.includes(rule)) {
            return true;
        }
        return false;
    };

    return (
        <div style={{display: 'block', color: 'black', marginBottom: '40px'}}>
            <IonHeader style={{backgroundColor: 'rgba(255,255,255,.8)'}}>
                <IonTitle style={{paddingTop: '10px', paddingBottom: '10px'}}>{pageTitle}</IonTitle>
            </IonHeader>

            <div style={{position: 'relative'}}>
                <div style={{position: 'absolute', zIndex: '11', top: '-4px'}}>
                    <IonButton className="btn-top-nav" size="small" routerLink="/aca" routerDirection="forward">Home</IonButton>
                    <IonButton className="btn-top-nav" size="small" routerLink="/aca/contacts" routerDirection="forward">Contacts</IonButton>
                    <IonButton className="btn-top-nav" size="small" routerLink="/aca/pipeline/1" routerDirection="forward">Opportunities</IonButton>
                    <IonButton className="btn-top-nav" size="small" routerLink="/aca/advanced-search" routerDirection="forward">Search</IonButton>
                    {hasRule('AcaBatch') &&
                        <IonButton className="btn-top-nav" size="small" routerLink="/aca/batch" routerDirection="forward">Batch Update</IonButton>
                    }
                    {hasRule('AcaOpsAdmin') &&
                    <IonButton className="btn-top-nav" size="small" routerLink="/aca/admin/settings" routerDirection="forward">Settings</IonButton>
                    }
                </div>
            </div>
        </div>
    )

}